import type {TId} from '@/assets/core/assets/api/types';
import type {ILayerUpdate} from '@/api/types/layer';
import type {ILayerFeatureStyleItem} from '@/api/types/layer/style';
import type {TWidget} from '@/api/types/layer/widget';
import type {ELayerFeatureSearchType} from '@/api/enums/layer';

import {layerAPI} from '@/api/requesters/layer';

const useLayerControllerHook = () => {
  const api = layerAPI.clone();

  const updateName = async (id: TId, name: string) => {
    return await api.updateOne(id, {name: name});
  };

  const updateLayer = async (id: TId, data: ILayerUpdate) => {
    return await api.updateOne(id, data);
  };

  const updateFolderId = async (id: TId, folderId?: TId) => {
    return await api.updateOne(id, {folder_id: folderId});
  };

  const updateResourcesId = async (id: TId, resourcesId: TId[]) => {
    return await api.updateOne(id, {resources_id: resourcesId});
  };

  const updateFeatureStyles = async (
    id: TId,
    styles?: ILayerFeatureStyleItem[],
  ) => {
    return await api.updateOne(id, {feature_styles: styles});
  };

  const updateStreams = async (id: TId, streams?: string[]) => {
    return await api.updateOne(id, {streams});
  };

  const updateFeatureSearch = async (
    id: TId,
    search?: Record<string, ELayerFeatureSearchType>,
  ) => {
    return await api.updateOne(id, {search});
  };

  const updateWidgets = async (id: TId, widgets?: TWidget[]) => {
    return await api.updateOne(id, {widgets});
  };

  const updateDevices = async (id: TId, devices: TId[]) => {
    return await api.updateOne(id, {devices});
  };

  return {
    ...api,

    search: api.cloneWithParams({}, {size: 3}),

    updateName,
    updateLayer,
    updateFeatureStyles,
    updateFolderId,
    updateResourcesId,
    updateStreams,
    updateFeatureSearch,
    updateWidgets,
    updateDevices,
  };
};

export const layerController = useLayerControllerHook();
